import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { Popover } from '@bingads-webui-react/popover';

export class SummaryContextMenu extends React.PureComponent {
  static propTypes = {
    /**
     * Name of choice and its eventHandler.
     */
    funcsInMenu: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      func: PropTypes.func.isRequired,
    })).isRequired,
    i18n: PropTypes.PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
  };

  constructor(props) {
    super(props);

    this.popover = null;
  }

  dismissPopover() {
    if (this.popover) {
      this.popover.dismissPopover();
    }
  }

  render() {
    const threeDots = (
      <div className="toggle-context-menu">
        <button
          className="iconba iconba-More"
          aria-label={this.props.i18n.getString('More options')}
        />
      </div>
    );

    return (
      <div className="summary-context-menu">
        <Popover
          trigger="click"
          target={threeDots}
          placement="bottom"
          ref={(popover) => { this.popover = popover; }}
        >
          <ul>
            {_.map(this.props.funcsInMenu, func => (
              <li key={func.name}>
                <button
                  className="btn btn-link btn-block"
                  onClick={() => {
                    this.dismissPopover();
                    func.func();
                  }}
                  disabled={func.disabled}
                >
                  {func.name}
                </button>
              </li>
              ))}
          </ul>
        </Popover>
      </div>
    );
  }
}
